export default "__VITE_PUBLIC_ASSET__eda857d9__"